// extracted by mini-css-extract-plugin
export var checkbox = "FormCheckbox-module--checkbox--bb9e4";
export var square = "FormCheckbox-module--square--9d634";
export var contentWrapper = "FormCheckbox-module--contentWrapper--f2e84";
export var input = "FormCheckbox-module--input--efa4d";